__turbopack_context__.v({
  "chip": "Chip-module-scss-module__P1VJha__chip",
});
